export const init = () => {
  const showCountryHeader = (countryCode) => {
    App.components.locale_header(window.__TGV_COUNTRIES, countryCode).init();
  };

  const locationOverrideParts = window.location.search.match(/x-tgv-location=([A-Z]{2})/);
  const locationOverride = locationOverrideParts && locationOverrideParts[1];

  // get user data if present, otherwise subscribe to its event
  if (window.__TGV_USER_DATA) {
    showCountryHeader(locationOverride || window.__TGV_USER_DATA.locationCountryCode);
  } else {
    $.subscribe('TGV_USER_DATA', (user) => {
      showCountryHeader(locationOverride || user.locationCountryCode);
    });
  }
};
